// This file should only contain action type constants.

export const SET_STANDARD_FEATURES = 'SET_STANDARD_FEATURES';
